import { render, staticRenderFns } from "./SurveyBase.vue?vue&type=template&id=01e2001e&"
import script from "./SurveyBase.vue?vue&type=script&lang=js&"
export * from "./SurveyBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports